import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IEntityAddressModel } from '@apps-common/types/management/entity-address'

export const getAddressesByEntity = async (entityId: string): Promise<IEntityAddressModel[]> =>
  axios.get(`/management/address/getaddressesbyentity?entityId=${entityId}`).then((res) => res.data?.data)

type QueryFnType = typeof getAddressesByEntity

type Props = {
  config?: QueryConfig<QueryFnType>
  entityId: string
}

export const useManagementGetAddressesByEntity = ({ config, entityId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getAddressesByEntity', entityId],
    queryFn: () => getAddressesByEntity(entityId)
  })
